var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullHeadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 120,
    rx: 60,
    ry: 50,
    fill: "#d4d4d4",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 85 Q50 70 45 60 Q40 55 35 50",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 85 Q150 70 155 60 Q160 55 165 50",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 105,
    r: 12,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 105,
    r: 8,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 105,
    r: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 135,
    rx: 18,
    ry: 12,
    fill: "#aaa",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95,
    cy: 135,
    rx: 3,
    ry: 5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105,
    cy: 135,
    rx: 3,
    ry: 5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 150 Q100 165 120 150",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 90 Q100 75 160 90",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 95 Q40 100 45 95",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 95 Q160 100 165 95",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullHeadIcon);
export default __webpack_public_path__ + "static/media/bull-head-icon.3e2d66536b01b3819a9944d272cea632.svg";
export { ForwardRef as ReactComponent };